import { ConversightStatus } from './types';

export const transformConversightStatus = (res: any): ConversightStatus => {
  if (!res || !res.orgStatus || !res.users) {
    return {
      startTime: null,
      endTime: null,
      status: null,
      message: null,
      users: null,
      url: null,
    };
  }

  return {
    startTime: res.orgStatus.startTime || null,
    endTime: res.orgStatus.endTime || null,
    status: res.orgStatus.status || null,
    message: null,
    users: res.users
      .map((el: any) => (el && typeof el.email === 'string' ? el.email : null))
      .filter(Boolean),
    url: res.orgStatus.domainUrl || null,
  };
};
